/**
 * Reads the CSRF token caleo-back sets in the `caleoCsrfToken` cookie.
 * caleo-back issues a new one on every login and session refresh.
 *
 * @returns The CSRF token, or undefined when the cookie is missing or empty.
 */
export const getCsrfCookieToken = (): string | undefined => {
  if (typeof document === 'undefined' || !document.cookie) {
    return undefined
  }

  const prefix = 'caleoCsrfToken='
  const cookiePart = document.cookie
    .split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(prefix))

  const token = cookiePart?.slice(prefix.length)
  return token ? decodeURIComponent(token) : undefined
}
